import React, {useState } from "react";
import Confirm from "../../../Modal/Confirm";
import DeleteIco from "../../../../assets/images/delete.svg";
import Axios from "../../../../axios";
function BlockTitle(props) {
    const [deleteBlockItem, setDeleteBlock] = useState(false);
  const [deleteBlockID, setDeleteBlockID] = useState(null);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
    const deleteBlock = (tempID,isDefault,activeTab) => {
    
        let data = {
          u: props.userID,
          sn: props.sessionID,
          t: tempID,
          isDef:isDefault
        };
        Axios.BlockService.POST_DELETE_BLOCK(data).then((response) => {
          if (response.data.statusCode == "success") {
            props.updateBlockState(props.index);
            // setTimeout
            setDeleteSuccess(true);
            setTimeout(function () {
              setDeleteSuccess(false);
            //   props.reloadBlock(activeTab);
              
              setDeleteBlock(false);
              setDeleteBlockID(null);
            }, 2000);
          }
        });
      };
    return (
            <p
                data-id={props.template_id}
                className={
                  "deleteBlock" +
                  (props.template_id == deleteBlockID
                    ? " loadingActive"
                    : " ")
                }
              >
                {deleteBlockItem &&
                  deleteBlockID == props.template_id &&
                  deleteSuccess == false ? (
                  <div className="loading"></div>
                ) : deleteBlockItem &&
                deleteBlockID == props.template_id &&
                deleteSuccess == true ? (
                  <div className="wrapperSaved">
                    <svg
                      version="1.1"
                      id="Layer_1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 98.5 98.5"
                      enableBackground="new 0 0 98.5 98.5"
                    >
                      <path
                        className="checkmark"
                        fill="none"
                        strokeWidth="8"
                        strokeMiterlimit="10"
                        d="M81.7,17.8C73.5,9.3,62,4,49.2,4
C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"
                      />
                    </svg>
                  </div>
                ) : deleteBlockItem == false &&
                deleteBlockID == null &&
                deleteSuccess == false ? (
                  <Confirm element="small" getConfirmation={
                      (status)=>{
                        if(status){
                          deleteBlock(props.template_id, props.is_default, props.index);
                          setDeleteBlock(!deleteBlockItem);
                          setDeleteBlockID(props.template_id);
                        }else{
                          // Do nothing
                        }
                      }}
                  >
                     <img src={DeleteIco} />
                  </Confirm>
                ) : null}
              </p>
    )
  }
export default BlockTitle;